<template>
  <div>
    <custom-actions>
      <template #header>

      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
        label-width="100px">

        <el-form-item label="所属流程" prop="nodeName">
          <el-select filterable clearable v-model="searchForm.nodeKey" placeholder="请选择所属流程">
            <el-option v-for="(item, index) of nodeList"  :value="item.dicCode"
                  :label="item.dicValue"
              :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <p class="tips">流程说明：k2用于(销售出库/客户提货出库)；k5用于(采购入库)；k6用于(调拨单)</p>
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="130" label="流程名称" prop="nodeKey"></el-table-column>
        <el-table-column min-width="120" label="节点名称" prop="nodeName">
          <template v-slot="{ row }">
            {{ row.nodeName }}({{ row.nodeId }})
          </template>
        </el-table-column>
        <el-table-column min-width="140" label="节点审批角色" prop="nodeRoleName">

        </el-table-column>
        <el-table-column min-width="140" label="下一个节点" prop="nextNode">

        </el-table-column>
        <el-table-column min-width="130" label="驳回节点" prop="upNode"></el-table-column>

        <el-table-column width="180" label="操作" fixed="right">
          <template v-slot="{ row }">

            <el-button type="text" @click="
              $router.push('/flowManage/detail?nodeId=' + row.nodeId)
              ">详情</el-button>
            <el-button type="text" @click="
              $router.push('/flowManage/edit?nodeId=' + row.nodeId+'&nodeKey='+row.nodeKey)
              " >编辑</el-button>

          </template>
        </el-table-column>
      </el-table>
<!--
      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination> -->
    </el-card>

  </div>
</template>

<script>

export default {
  name: 'FlowManage',

  data() {
    return {
      tableData: [],

      // page: 1,
      // total: 0,
      loading: false,
      searchForm: {
        nodeKey: null
      },
      nodeList: []

    }
  },
  computed: {

  },
  created() {
    this.loadDict().then(() => {
      this.loadData()
    })
  },

  methods: {
    loadDict () {
      return this.$axios.get(this.$apis.common.selectDicByList, {
        params: { dicType: 'processType' }
      }).then(res => {
        this.nodeList = res.processType
        this.searchForm.nodeKey = res.processType[0].dicCode
      })
    },
    loadData() {
      const params = {
        // page: this.page,
        ...this.searchForm
      }
      console.log('params', params)
      this.$axios
        .get(this.$apis.flowManage.selectYgNodeByList, {
          params: params
        })
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.onSearch()
    }

  }
}
</script>

<style scoped lang="scss">
.tips {
  font-size: 12px;
  margin-bottom: 15px;
}
</style>
